export default __webpack_public_path__ + "static/media/dsc-sort.fad0d6a5.svg";